export default __webpack_public_path__ + "static/media/title_image.caa71fc2.jpg";